<template>
  <v-sheet elevation="0" class="pa-3 text-center">
    <Slogen />
    <h1 class="py-5 grey--text">
      <v-icon class="mb-2" size="25" color="info">mdi-auto-fix</v-icon>
      <strong class="iconFont blue--text">{{ title }}</strong> is comming soon..
    </h1>
  </v-sheet>
</template>
<script lang="ts">
import Vue from "vue";
import Slogen from "@/components/Slogen.vue";

export default Vue.extend({
  name: "DevView",
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$route.name || "";
    },
  },
  components: { Slogen },
});
</script>
<style></style>
